import { computed } from 'vue';

import { GlobalState } from '@/global';
import { DataCache } from '@/shared/data/cache';
import { hasPermission } from '@/shared/helpers/permissions.helpers';

/**
 * Whether this tenant still has ZynoTalk onboarding to finish (`GET /tenant` → `onboardingStatus`).
 *
 * Drives the attention badges on Admin in the app sidebar and on Admin → ZynoTalk → Overview, so
 * both read one value and can't disagree. Sibling of `isModernTalkBackend` and backed by the same
 * `talkTenant` cache entry: one request per tenant, re-fetched on a tenant switch.
 *
 * Gated on tenant-admin + the Talk permission before it reads the cache. Onboarding is an admin task
 * and the badge points at an admin screen, so a user who could never act on it shouldn't be shown a
 * badge — nor have a Talk request made on their behalf just to decide not to show one.
 */
export const isTalkOnboardingActive = computed<boolean>(() => {
    if (!GlobalState.tenant.value?.isAdmin || !hasPermission('talk')) return false;
    return DataCache.getLazyRef('talkTenant').value?.onboardingStatus === 'active';
});

/** Returns the shared flag, kicking the (tenant-scoped, deduped) load if it hasn't run yet. */
export function useIsTalkOnboardingActive() {
    if (GlobalState.tenant.value?.isAdmin && hasPermission('talk')) DataCache.getRef('talkTenant');
    return isTalkOnboardingActive;
}
